import { ApiGrid } from "../controls/ApiGrid";
import { type Nationality } from '../../../../lecturas-common/location/nationality.model';
import { Column, ColumnType, type ColumnTemplateProps, type EditTemplateProps } from "@syncfusion/react-grid";
import { NationalitiesDataSource } from "../../services/nationalities-data-source";
import { ContinentsDataSource } from "../../services/continents-data-source";
import { useCallback, useEffect } from "react";
import type { Continent } from "../../../../lecturas-common/location/continents.model";
import { ApiMultiSelect } from "../controls/ApiMultiSelect";



export const NationalitiesPage = () => {

    const dataSource = new NationalitiesDataSource();

    const continentsDataSource = new ContinentsDataSource();

    const continents = continentsDataSource.data; 

    useEffect(()=>{
            continentsDataSource.get();
        },[]);

    const continentsTemplate = useCallback((props?: ColumnTemplateProps): React.ReactElement => {
        let nationality =  props?.data as Nationality;
        

        return (<p>{nationality?.continents?.map(c => c.name).join()}</p>);
    
    },
     []);
    const continentsEditTemplate = useCallback((props?: EditTemplateProps): React.ReactElement => {
        let nationality =  props?.data as Nationality;
        

        return (<ApiMultiSelect<Continent> 
            dataSource={continentsDataSource} 
            placeHolder="Continentes"
            fields={{value:'id', text:'name'}}
            onChange={(val) => { 
                nationality.continents = val;
                props?.onChange(val);
            }}
            value={nationality.continents}>

        </ApiMultiSelect>);
    
    },
     [continents]);
    return (
        <ApiGrid<Nationality> dataSource={dataSource}>
            <Column field="id" isPrimaryKey={true} isIdentity={true} validationRules={{required: false}} visible={false}/>
            <Column field="name" validationRules={{required: true, minLength: 4}}  headerText="Nombre"/>
            <Column field="continents" 
                    headerText="Continentes"
                    editTemplate={continentsEditTemplate}
                    template={continentsTemplate}>

                    </Column>
            <Column 
            field="createdAt" 
            headerText="Creado" 
            type={ColumnType.DateTime} 
            format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
            editTemplate={<p></p>}
            validationRules={{required: false}} 
            allowEdit={false}/>
            <Column 
            field="updatedAt" 
            headerText="Actualizado" 
            type={ColumnType.DateTime} 
            format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
            editTemplate={<p></p>}
            validationRules={{required: false}} 
            allowEdit={false}/>         
        </ApiGrid>
    );
}